import React from 'react'
import { Wrapper } from "./instructionOverlayStyle";

import swipeIcon from "../../assets/images_1/swipe-icon-23.jpg.png";
import swipeCustom from "../../assets/images_1/Scroll-Indocator@2x.png";
import swipepointer from "../../assets/images_1/scroll-pointer-icon.svg"
import arrows from "../../assets/images_1/arrows@2x.png";
import swipelast from "../../assets/images_1/swipe-last@2x.png";
import { FaRegHandPointer } from "react-icons/fa";
import mouseIcon from '../../assets/ademars/mouse_pointer.png'
import touchIcon from '../../assets/ademars/touch_icon.png'
import rightArrow from '../../assets/ademars/right-arrow.png'


export default function InstructionOverlay({setShowInsrtuctionOverlay}) {
    return (
        <Wrapper onClick={()=> {
                setShowInsrtuctionOverlay(false)
                document.body.style.overflow = 'hidden'
            }}>
            <div className="desktop-items" style={{display:'flex', alignItems:'center',justifyContent:'center', width:'100%'}}>     
                <img width={70} className="desktop-items" src={mouseIcon} />
                <img width={70} className="desktop-items"  src={rightArrow} />
                <img  width={70} className="mobile-items" src={touchIcon}  />
            </div>
            <p className="mobile-items">Swipe to navigate</p>
            <p className="desktop-items">Swipe or Click arrow to navigate</p>
        </Wrapper>
    )
}
